/**
 * Created by gmogas on 31/3/2017.
 */
(function() {
    'use strict';

    angular
        .module('sigmasfApp')
        .config(stateConfig);

    stateConfig.$inject = ['$stateProvider'];

    function stateConfig($stateProvider) {
        $stateProvider
            .state('productLots', {
                parent: 'masterData',
                url: '/productLots',
                data: {
                    authorities: ['ROLE_SYSTEM','ROLE_ADMIN','ROLE_MANAGEMENT', 'ROLE_ACCOUNTING_DEP']
                },
                views: {
                    'content@': {
                        templateUrl: 'app/masterData/productLots/productLots.html',
                        controller: 'ProductLotsController',
                        controllerAs: 'vm'
                    }
                },
                params: {
                    search: null
                },
                resolve: {
                    pagingParams: ['$stateParams', function ($stateParams) {
                        return {
                            search: $stateParams.search
                        };
                    }],
                    translatePartialLoader: ['$translate', '$translatePartialLoader', function ($translate, $translatePartialLoader) {
                        $translatePartialLoader.addPart('masterData');
                        $translatePartialLoader.addPart('global');
                        return $translate.refresh();
                    }]
                }
            })
    }

})();
